/* eslint-disable react/require-default-props */

import React from 'react';
import {PixelRatio, View} from 'react-native';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {tt} from '/provider/TranslationProvider/TranslationProvider.util';

import {styles} from './ErrorBanner.style';

type Props = {
  errorCount: number;
  hasSubmitted: boolean;
  testID?: string;
};

export const ErrorBanner = ({errorCount, hasSubmitted, testID}: Props) => {
  if (!hasSubmitted || errorCount === 0) {
    return null;
  }

  const iconFontScale = PixelRatio.getFontScale();
  const dynamicIconSize = Math.min(20 * Math.max(iconFontScale, 1), 28);

  const label =
    errorCount === 1
      ? tt('errorBannerSingle', 'Please fix the error below before saving')
      : tt(
          'errorBannerMulti',
          `Please fix the ${errorCount} errors before saving`,
        );

  return (
    <KeyboardFocusable
      testID={testID}
      accessible
      accessibilityRole="alert"
      accessibilityLabel={label}>
      <View style={styles.container} accessible={false}>
        <View
          style={styles.iconWrapper}
          accessible={false}
          testID={`${testID}-icon`}>
          <Icon
            name="info"
            style={[styles.icon, {fontSize: dynamicIconSize}]}
            accessible={false}
          />
        </View>
        <View style={styles.textWrapper} accessible={false}>
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.text}
            accessible={false}
            testID={`${testID}-text`}>
            {label}
          </Text>
        </View>
      </View>
    </KeyboardFocusable>
  );
};
